module.exports = __webpack_public_path__ + "static/img/touxiang.cc8d8b2c.png";